<template>
  <section class="accidentaldamage">
    <div
      class="container aos-init aos-animate"
      data-aos="fade"
      data-aos-duration="2000"
    >
      <span
        class="poweredby"
        style="font-size: 14px; padding: 8px !important; margin-bottom: 10px"
      >
        &nbsp;Optional Add-on&nbsp;
      </span>
      <br /><br />
      <h3>Accidental Damage Personal Property Coverage</h3>
      <p>
        Coverage if you crack your phone screen or spill coffee on your laptop.
      </p>
      <button @click="showAccidentalDamageModal()">Learn More</button>
    </div>
    <div style="clear: both"></div>
  </section>
  <BaseModal :name="modalLabel + '2'">
    <accidental-damage-modal />
  </BaseModal>
</template>

<script lang="ts" setup>
import BaseModal from "@/views/modals/BaseModal.vue";
import useModal from "@/hooks/useModal";
import Modals from "@/utils/Modals";
import AccidentalDamageModal from "@/views/modals/context/AccidentalDamageModal.vue";

const modalLabel = Modals.ACCIDENTAL_DAMAGE_MODAL.label;
const { toggleModal } = useModal();
const showAccidentalDamageModal = () => {
  toggleModal(Modals.ACCIDENTAL_DAMAGE_MODAL.label + "2");
};
</script>
